import type { QnAItem } from '@/types/domain';
import styles from './ProfileFeed.module.css';

export function QnACard({ item }: { item: QnAItem }): JSX.Element {
  return (
    <article className={styles.card}>
      <strong className={styles.qnaQuestion}>{item.question}</strong>
      <p className={styles.qnaAnswer}>{item.answer}</p>
    </article>
  );
}
